import { Component } from 'react';
import moment from "moment";

class DateOps extends Component {
    


    ConvertToFarmTimeZone(date_, type_,) {
        var minutes_;
        if (this.props.skip_local) {
            minutes_ = this.props.localTimeZone;
        }
        else {
            minutes_ = new Date().getTimezoneOffset() + this.props.localTimeZone;
        }
        //var min = minutes_ % 60;
        date_.setMinutes(date_.getMinutes() + minutes_);
        var date = this.ConvertDateTimeFormat(date_, type_);
        return date;
    }

    ConvertDateTimeFormat(request_date, type_) {
        const timeFormat = "ddd MMM DD YYYY HH:mm:ss";
        //Sat Sep 24 2022 15:08:30
        const dateFormat = "DD-MMM-YYYY";
        const onlyTimeFormat = "HH:mm A";
        var date;
        if (type_ === "TIME") {
            date = moment(request_date).format(timeFormat);
            return date;
        }
        else if (type_ === "DATE") {
            date = moment(request_date).format(dateFormat);
            return date;
        }
        else if(type_ === "STIME") {
            date = moment(request_date).format(onlyTimeFormat);
            return date;
        }
        else {
            date = moment(request_date).format(dateFormat);
            return date;
        }
    }
    render() {
        //console.log("" + this.ConvertToFarmTimeZone(this.props.date_, this.props.type_));
        //console.log("props.test:"+this.props.test);
        //return "sddsg";
        return "" + this.ConvertToFarmTimeZone(this.props.date_, this.props.type_);
    }

}

export default DateOps;

